/**
 * Parts of the interface the Python backend does not serve. The rest of the
 * interface is kept, and comes back as each part is ported.
 */
export const FEATURES = {
  /** The judge's agreement with the studio's marks: there is no judge for now. */
  calibration: false,
} as const;
